import { getEquipmentRequest } from '../../services/equipment';
import { EQUIPMENT_CACHE_KEY } from '../../services/queryKeys';
import { useAxiosQuery } from '../useAxiosQuery';
import { Equipment, EquipmentHookReturn } from './types';

export function useGetEquipment(organisationId: string): EquipmentHookReturn {
  const {
    data: equipment,
    isLoading,
    error,
    refetch,
  } = useAxiosQuery<Equipment[]>(EQUIPMENT_CACHE_KEY(organisationId), getEquipmentRequest(organisationId).path, {
    enabled: !!organisationId,
  });

  return {
    equipment: equipment || [],
    isLoading,
    error: error ? String(error) : null,
    refetch,
  };
}
